import moment from "moment";
import constants from "../../Utils/constants";
import bagImg from "../../assets/img/employeSVG.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { formatDurationBetweenDates, haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";

const DetailsEmploymentInfo = (props) => {
  const {
    user = null,
    forensicAnalysis = {},
    handleInfoModal,
    isFromReport,
    currentLang,
    llShowOnly,
  } = props;

  const { _t } = useTranslator();

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }

    return _t("na");
  };

  const employementType = haveValue(
    forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
  )
    ? forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
    : user?.employment_status;

  const employmentHistory =
    forensicAnalysis?.["Employment History"]?.dataInJSON?.employmentHistory;

  const currentEmployers = Array.isArray(employmentHistory)
    ? employmentHistory.filter((item) => item?.jobEndOn === null)
    : [];

  const activeEmployers =
    currentEmployers.length > 0
      ? currentEmployers
      : employmentHistory?.[0]
        ? [employmentHistory[0]]
        : [];

  const isEmployed = user?.employment_status === constants.employed;

  const hasMultipleCurrentEmployers = isEmployed && currentEmployers.length > 1;

  const locale = currentLang || localStorage.getItem("i18nextLng");

  const isNotStudent = !(user?.employment_status ?? "")
    .toLowerCase()
    ?.includes(constants.student);

  const showMultipleTag =
    user?.forensic_status === "COMPLETED" &&
    isNotStudent &&
    hasMultipleCurrentEmployers;

  const visibleEmployers = isEmployed
    ? activeEmployers
    : activeEmployers.slice(0, 1);

  return (
    <>
      <div className={`main_doc_div ${isFromReport ? "h-100" : "mt-3"}`}>
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={bagImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("employmentInformation")}</p>
          {showMultipleTag && (
            <span className="monthly-badge">
              {_t("severalEmployersDetected")}
            </span>
          )}
        </div>
        <div className="row">
          {(user?.forensic_status !== "COMPLETED" ||
            visibleEmployers.length === 0 ||
            user?.employment_status?.toUpperCase() ==
              constants.unemployed.toUpperCase() ||
            !isNotStudent) && (
            <div className="col-md-4">
              <div className={`Indo_form BorderB2`}>
                <div className="d-flex align-items-center gap-1">
                  <p className="formlabel d-block">{_t("employmentStatus")}</p>
                </div>
                <p className="placeholderTest">{getEmploymentStatus()}</p>
              </div>
            </div>
          )}
          {user?.employment_status?.toUpperCase() ==
          constants.unemployed.toUpperCase() ? null : (
            <>
              {user?.forensic_status === "COMPLETED" ? (
                <>
                  {isNotStudent ? (
                    <>
                      {visibleEmployers.map((item, idx) => {
                        if (!item) return null;
                        const entrySeniority = formatDurationBetweenDates(
                          item?.jobStartedOn,
                          item?.jobEndOn,
                          null,
                          locale
                        );
                        const formattedStartDate = moment(
                          item?.jobStartedOn
                        ).format("DD/MM/YYYY");
                        const hasEntrySeniority =
                          haveValue(item?.jobStartedOn) &&
                          haveValue(entrySeniority);

                        const resolvedEmploymentType =
                          item?.employmentType ||
                          forensicAnalysis?.["Employment Type"]?.dataInJSON
                            ?.employmentType ||
                          null;
                        const displayEmploymentType = resolvedEmploymentType
                          ? _t(resolvedEmploymentType)
                          : getEmploymentStatus();

                        return (
                          <div className="col-12 row mx-0 px-0" key={idx}>
                            {haveValue(displayEmploymentType) && (
                              <div className="col-md-4">
                                <div className="Indo_form BorderB2">
                                  <div className="d-flex align-items-center gap-1">
                                    <p className="formlabel d-block">
                                      {_t("employmentStatus")}
                                    </p>
                                    {forensicAnalysis?.["Employment History"]
                                      ?.verifiedSource == true && (
                                      <img
                                        src={CheckIcon0}
                                        alt="Vector Icon"
                                        className="validationIcon"
                                      />
                                    )}
                                  </div>
                                  <p className="placeholderTest">
                                    {displayEmploymentType}
                                  </p>
                                </div>
                              </div>
                            )}
                            <div
                              className={`col-md-4 ${
                                haveValue(
                                  forensicAnalysis?.["Employment History"]
                                ) && llShowOnly
                                  ? "cursor-pointer custom-tooltip"
                                  : ""
                              }`}
                              data-tooltip={_t("clickHereToSeeDetails")}
                              onClick={(e) => {
                                if (
                                  haveValue(
                                    forensicAnalysis?.["Employment History"]
                                  ) &&
                                  llShowOnly
                                ) {
                                  handleInfoModal(
                                    forensicAnalysis?.["Employment History"]
                                  );
                                }
                              }}
                            >
                              <div className="Indo_form BorderB2">
                                <div className="d-flex align-items-center gap-1">
                                  <p className="formlabel d-block">
                                    {_t("employerName")}
                                  </p>
                                  {forensicAnalysis?.["Employment History"]
                                    ?.verifiedSource == true ? (
                                    <img
                                      src={CheckIcon0}
                                      alt="Vector Icon"
                                      className="validationIcon"
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <p className="placeholderTest">
                                  {item?.employerName || _t("na")}
                                </p>
                              </div>
                            </div>
                            {llShowOnly && hasEntrySeniority ? (
                              <div className="col-md-4">
                                <div className="Indo_form BorderB2">
                                  <div className="d-flex align-items-center gap-1">
                                    <p className="formlabel d-block">
                                      {_t("employeeSeniority")}
                                    </p>
                                    {forensicAnalysis?.["Employment History"]
                                      ?.verifiedSource == true ? (
                                      <img
                                        src={CheckIcon0}
                                        alt="Vector Icon"
                                        className="validationIcon"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  <p className="placeholderTest">
                                    {`${formattedStartDate} (${entrySeniority})`}
                                  </p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="col-md-4">
                      <div
                        className={`Indo_form BorderB2  ${
                          haveValue(forensicAnalysis?.["University Name"]) &&
                          llShowOnly
                            ? "cursor-pointer custom-tooltip"
                            : ""
                        }`}
                        data-tooltip={_t("clickHereToSeeDetails")}
                        onClick={(e) => {
                          if (
                            haveValue(forensicAnalysis?.["University Name"]) &&
                            llShowOnly
                          ) {
                            handleInfoModal(
                              forensicAnalysis?.["University Name"]
                            );
                          }
                        }}
                      >
                        <div className=" d-flex align-items-center gap-1">
                          <p className="formlabel d-block">
                            {_t("universityName")}
                          </p>
                          <div className=" d-flex align-items-center gap-1">
                            {forensicAnalysis?.["University Name"]
                              ?.verifiedSource == true ? (
                              <img
                                src={CheckIcon0}
                                alt="Vector Icon"
                                className="validationIcon"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <p className="placeholderTest">
                          {forensicAnalysis?.["University Name"]?.dataInJSON
                            ?.universityName
                            ? forensicAnalysis?.["University Name"]?.dataInJSON
                                ?.universityName
                            : _t("na")}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailsEmploymentInfo;
